import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import { getAllNotificationAction } from '@/Module/Profile/Store/Action';
import { getTotalNotificationAction } from '@/Module/Profile/Store/Action/getTotalNotificationAction';
import { notificationAdapter } from '@/Module/Profile/Store/Adapter';

const NotificationSlice = createSlice({
  name: 'notification',
  initialState: {
    isLoading: false,
    notifications: notificationAdapter.getInitialState(),
    page: 0,
    rows: 12,
    total: 0,
    totalUnread: 0,
    totalRead: 0,
    totalUnreadMenu: 0,
  },
  reducers: {
    setPage: (state, { payload }: PayloadAction<number>) => {
      state.page = payload;
    },
    nextPage: state => {
      state.page += 1;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(getAllNotificationAction.pending, state => {
        state.isLoading = true;
      })
      .addCase(getAllNotificationAction.rejected, state => {
        state.isLoading = false;
      })
      .addCase(getAllNotificationAction.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.total = payload.total;
        state.totalUnread = payload.totalUnread;
        state.totalRead = payload.totalRead;
        if (state.page === 0) {
          notificationAdapter.setAll(state.notifications, payload.data);
        } else {
          notificationAdapter.addMany(state.notifications, payload.data);
        }
      });
    builder
      .addCase(getTotalNotificationAction.pending, state => {
        state.isLoading = true;
      })
      .addCase(getTotalNotificationAction.rejected, state => {
        state.isLoading = false;
      })
      .addCase(getTotalNotificationAction.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.totalUnreadMenu = payload.totalUnread;
      });
  },
});

export default NotificationSlice;
